import * as t from 'io-ts';

import {readRecentSearchQueries} from '../../../../../srcCommon/services/storage/recentSearchQueries';
import {makeEnumRuntimeType} from '../../../../models/api/apiTypes';
import {RSearchHint} from '../../../../models/api/searchHintModel';
import {RSearchSuggestionMatches} from '../../../../models/api/searchSuggestionMatchModel';
import {InboxesSearchLocationsEnum} from '../../../../models/url/inboxesUrlModel';

/*
 * Runtime types.
 */

const RInboxesSearchLocationsEnum = makeEnumRuntimeType(InboxesSearchLocationsEnum);
const RCellsPanelSearchResultsCountsState = t.record(
  RInboxesSearchLocationsEnum,
  t.union([t.undefined, t.number]),
);

const RCellsPanelSearchSuggestionsState = t.type({
  isLoading: t.boolean,
  results: t.union([RSearchSuggestionMatches, t.null]),
});

const RCellsPanelSearchHintsState = t.type({
  isLoading: t.boolean,
  results: t.union([t.readonlyArray(RSearchHint), t.null]),
});

export enum HighlightAlgorithmsEnum {
  DEFAULT = 'default',
  TRIM_CHARS_MULTIPLIER_3 = 'trim_chars_multiplier_3',
  BUMP_HIGHLIGHT_LENGTH = 'bump_highlight_length',
}
const RHighlightAlgorithmsEnum = makeEnumRuntimeType(HighlightAlgorithmsEnum);

export const RCellsPanelSearchState = t.type({
  resultsCounts: RCellsPanelSearchResultsCountsState,
  searchSessionTimestamp: t.union([t.number, t.null]),
  recentQueries: t.readonlyArray(t.string),
  suggestions: RCellsPanelSearchSuggestionsState,
  hints: RCellsPanelSearchHintsState,
  highlightAlgorithm: t.union([RHighlightAlgorithmsEnum, t.undefined]),
});

/*
 * Types.
 */

export type CellsPanelSearchState = Readonly<t.TypeOf<typeof RCellsPanelSearchState>>;
export type CellsPanelSearchResultsCounts = Readonly<t.TypeOf<typeof RCellsPanelSearchResultsCountsState>>;

/*
 * Helpers.
 */

export const DEFAULT_SEARCH_RESULTS_COUNTS = {
  [InboxesSearchLocationsEnum.LOCAL]: undefined,
  [InboxesSearchLocationsEnum.PINNED_IN_WORKSPACE]: undefined,
  [InboxesSearchLocationsEnum.GLOBAL]: undefined,
};

export function makeCellsSearchState(): CellsPanelSearchState {
  return {
    resultsCounts: DEFAULT_SEARCH_RESULTS_COUNTS,
    searchSessionTimestamp: null,
    recentQueries: readRecentSearchQueries(),
    suggestions: {
      isLoading: false,
      results: null,
    },
    hints: {
      isLoading: false,
      results: null,
    },
    highlightAlgorithm: undefined,
  };
}
